import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_USER',
  name: 'Workspace User',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
